var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "address-autocomplete",
      attrs: { id: "address-autocomplete" }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.search,
            expression: "search"
          }
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          placeholder: _vm.placeholder
            ? _vm.placeholder
            : _vm.lang.placeholders.address_autocomplete,
          disabled: _vm.disabled
        },
        domProps: { value: _vm.search },
        on: {
          focus: _vm.onFocus,
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.search = $event.target.value
            },
            _vm.autocomplete
          ],
          keyup: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.selectResult.apply(null, arguments)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              return _vm.chooseResult(1)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              return _vm.chooseResult(-1)
            }
          ],
          "!keydown": [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              $event.preventDefault()
              $event.stopPropagation()
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.preventDefault()
              $event.stopPropagation()
            }
          ]
        }
      }),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.results.length && _vm.show,
              expression: "results.length && show"
            }
          ],
          ref: "address_autocomplete_results",
          staticClass: "address-autocomplete-results"
        },
        _vm._l(_vm.firstResults, function(result) {
          return _c(
            "li",
            {
              key: result.id,
              staticClass: "address-result",
              class: result.count == _vm.result_selected ? "selected" : "",
              attrs: { id: "result_" + result.count },
              on: {
                click: function($event) {
                  return _vm.setResult(result)
                }
              }
            },
            [_c("span", { domProps: { innerHTML: _vm._s(result.place_name) } })]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }